import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'client-review',
  templateUrl: './client-review.component.html',
  styleUrls: ['./client-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientReviewComponent {
  @Input() data: {
    summary?: string;
    date?: string;
    review: string;
    from: string;
    img: string;
    details: string;
  };
}
